class ProductCardImages extends HTMLElement {
  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    const scroller = this.querySelector('.js-product-card-images-scroller');
    const pagination = this.querySelector('.js-product-card-images-scroller-pagination');
    const paginationItemActiveClass = 'product-card__images-pagination-item--active';

    if (!scroller) return;

    const scrollerRect = scroller.getBoundingClientRect();

    scroller.scrollLeft = 0;

    this.classList.add('product-card__images--ready');

    scroller.addEventListener('scroll', debounce(() => {
      if (scroller.scrollLeft < (scrollerRect.width / 2)) {
        scrollerPaginate(0);
        return;
      }

      scrollerPaginate(1);
    }, 150));

    function scrollerPaginate(current) {
      if (!pagination) return;
      
      const paginationItems = pagination.querySelectorAll('.js-product-card-images-scroller-pagination-item');

      paginationItems.forEach((el, index) => {
        el.classList.remove(paginationItemActiveClass);

        if (index === current) {
          el.classList.add(paginationItemActiveClass);
        } 
      });
    }
  }
}

customElements.define('product-card-images', ProductCardImages);
